import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Employee } from '@shared/models/policies/detail/employee/employee';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';

import employeesMock from '@mocks/employees.json';
import { EmployeeResponse } from '@shared/models/policies/detail/employee/employeeResponse';
import { map } from 'rxjs/operators';
import { DateFormatPipe } from '@core/pipes/date-format.pipe';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  private employees: Array<Employee> = [];

  constructor(
    private commonService: CommonService,
    private http: HttpClient,
    private dateFormatPipe: DateFormatPipe
  ) {
    this.employees = employeesMock;
  }

  getEmployees(vatNumber: string): Observable<Array<Employee>> {
    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next(this.employees))
    }

    return this.http.get<Array<Employee>>(this.commonService.getServiceUrl(`employee/${vatNumber}`));
  }

  insertEmployee(employee: Employee): Observable<EmployeeResponse> {
    employee['ico'] = this.commonService.getLoggedUser().vatNumber;

    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next({
          id: 2
      } as EmployeeResponse));
    }

    return this.http.post<EmployeeResponse>(this.commonService.getServiceUrl('employee'), employee);
  }

  updateEmployee(employee: Employee): Observable<EmployeeResponse> {
    return this.http.put<EmployeeResponse>(this.commonService.getServiceUrl('employee'), employee);
  }

  private mapEmployees(employees: Array<Employee>): Array<Employee>{

    employees.forEach(employee => {
      employee.dateOfBirth = this.dateFormatPipe.transform(employee.dateOfBirth)
    });

    return employees;
  }

}
